const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

export const clientEnv = Object.freeze({
  apiBaseUrl: configuredApiBaseUrl || "/api",
  appVersion: import.meta.env.VITE_APP_VERSION?.trim() || "1.1.0"
});

